// extracted by mini-css-extract-plugin
export default {"popup":"OepGSYMaBtDR8M9cOpee","icon":"fZ7beya5R7DDSMWiA4zY"};